module.exports = __webpack_public_path__ + "img/category-brand.67854472.png";